import React from "react";
import { FetchBoundary } from "../../../common/FetchBoundary";
import { useFetch } from "../../../Hooks/useFetch";
import { displayBalance } from "../../../utils/Helpers";

export const PurchasesByIdentifier = ({ account }) => {
  const identifierPurchasesFetcher = useFetch(
    `/api/covered_entities/${account.id_340b}/accounts/${account.id}/purchases_by_identifier`
  );
  const identifierPurchases = identifierPurchasesFetcher?.data?.purchases ?? [];

  return (
    <div>
      <div className="my-3">
        <div className="t--500 pb-2">Purchases by Identifier</div>
        <div className="t--sm t--secondary">
          The purchases for the identifiers listed below require claim submissions to validate. To
          view and manage all identifiers mapping to this the account, visit the Pharmacies tab.
        </div>
      </div>

      <FetchBoundary {...identifierPurchasesFetcher}>
        {identifierPurchases.length === 0 ? (
          <div className="bg--light-navy flex align-items-center justify-content-center border--rounded t--sm t--secondary w--full h--96">
            No purchases
          </div>
        ) : (
          <div className="t--left t--sm container-fluid row-border-rounded">
            <div className="row align-items-center py-3 row-header t--500">
              <div className="col">Identifier</div>
              <div className="col">Type</div>
              <div className="col">Unvalidated Purchases</div>
            </div>
            {identifierPurchases
              .sort((a, b) => b.purchase_count - a.purchase_count)
              .map((idp) => {
                return (
                  <div
                    className="row align-items-center bg--white row-border-bottom h--48"
                    key={idp.identifier}
                  >
                    <div className="col t--500">{idp.identifier}</div>
                    <div className="col">{idp.identifier_type.toUpperCase()}</div>
                    <div className="col">{displayBalance(idp.purchase_count)}</div>
                  </div>
                );
              })}
          </div>
        )}
      </FetchBoundary>
    </div>
  );
};
